var $ = require('jquery'),
  GetDownloadUrls = require('widgets/getDownloadUrls')

module.exports = function (container) {
  var ued = window.ued || {},
    section = container.find('.header-c2'),
    defaultBtUrl = section.find('.channel-dl-pc').attr('href'),
    data = {}
  if (defaultBtUrl != 'javascript:;') {
    data.dlSiteInfo = {
      url: defaultBtUrl,
      dataBiClick: 'g_1_' + ued.gameCode + '_download',
      sourceOfficial: false,
    }
  }

  var newGameCodes = {}
  if (ued.newgameCodes) {
    if (typeof ued.newgameCodes.iOS != 'undefined') {
      newGameCodes.ios = ued.newgameCodes.iOS
    }
    if (typeof ued.newgameCodes.Android != 'undefined') {
      newGameCodes.android = ued.newgameCodes.Android
    }
    if (typeof ued.newgameCodes.PC != 'undefined') {
      newGameCodes.pc = ued.newgameCodes.PC
    }
  }

  // 20240411去掉“电脑版下载”，使用正常的下载逻辑
  // var getDownloadUrls = new GetDownloadUrls(newGameCodes)
  // 如果是手游则判断有没有雷电合作链接
  // if (ued.isMobileGame) {
  //   $.when(getDownloadUrls.getPlatformUrl('100000' + ued.gameId, true)).then(
  //     function (res) {
  //       // source 为 20 表示是联运的，为 40 表示是官方
  //       if (res.data && res.data.source == 20) {
  //         section
  //           .find('.channel-dl')
  //           .attr('href', res.data.downloadUrl)
  //           .attr('target', '_self')
  //           .text('电脑版下载»')
  //           .show()
  //       } else {
  //         render()
  //       }
  //     }
  //   )
  // } else {
  //   render()
  // }
  render()

  function render() {
    ued.emitter.on('NEWGAME-INFO-DOWNLOADTEXT', function () {
      $('.channel-dl')
        .show()
        .on('click', function () {
          $('.gb-newgame-comm-btn a').click()
        })
    })
  }
}
